import React from "react";

export default function Logo({ className = "", withWordmark = true }) {
  return (
    <span className={`dma-logo ${className}`} aria-hidden="false">
      <svg
        className="dma-logo__mark"
        viewBox="0 0 48 48"
        width="32"
        height="32"
        role="img"
        aria-label="Dataminerarg"
      >
        <defs>
          <linearGradient id="dmaGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#0F2A4A" />
            <stop offset="100%" stopColor="#1F4E8C" />
          </linearGradient>
        </defs>
        <rect x="2" y="2" width="44" height="44" rx="10" fill="url(#dmaGrad)" />
        <path
          d="M10 34 L20 22 L26 29 L34 16 L38 22"
          fill="none"
          stroke="#E9C6A6"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="20" cy="22" r="2.2" fill="#E9C6A6" />
        <circle cx="26" cy="29" r="2.2" fill="#E9C6A6" />
        <circle cx="34" cy="16" r="2.2" fill="#E9C6A6" />
        <path d="M10 40 H38" stroke="#E9C6A6" strokeWidth="1.2" opacity="0.7" />
      </svg>
      {withWordmark && (
        <span className="dma-logo__wordmark">
          <span className="dma-logo__word">Data</span>
          <span className="dma-logo__word dma-logo__word--accent">miner</span>
          <span className="dma-logo__word">arg</span>
        </span>
      )}
    </span>
  );
}
